// extracted by mini-css-extract-plugin
export var earth = "Background-module--earth--EQePT";
export var flip = "Background-module--flip--MLUod";
export var marquee1 = "Background-module--marquee1--gRvll";
export var marquee2 = "Background-module--marquee2--kFHDV";
export var marquee3 = "Background-module--marquee3--eFsSz";
export var marquee4 = "Background-module--marquee4--wx2-f";
export var marquee5 = "Background-module--marquee5--BdeyS";
export var pivot = "Background-module--pivot--nn3Hs";